import i18n from 'i18next';
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const DEFAULT_LANGUAGE =
  (process.env.REACT_APP_DEFAULT_LANGUAGE || 'en').split('-')[0];

i18n
  .use(Backend) // load translations from public/locales
  .use(LanguageDetector) // detect language (localStorage, browser settings)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    debug: false,
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
